document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".slick-prev.slick-arrow svg").forEach(function (svg) {
    svg.setAttribute("aria-label", "Previous Slide");
    svg.setAttribute("role", "button");
    svg.setAttribute("tabindex", "0");
  });

  document.querySelectorAll(".slick-next.slick-arrow svg").forEach(function (svg) {
    svg.setAttribute("aria-label", "Next Slide");
    svg.setAttribute("role", "button");
    svg.setAttribute("tabindex", "0");
  });
});

document.addEventListener("DOMContentLoaded", function () {
  function removeAttributes() {
    document.querySelectorAll(".slick-track, .slick-slide .testimonials-slide").forEach(function (element) {
      element.removeAttribute("role");
      element.removeAttribute("aria-describedby");
    });
  }

  removeAttributes();

  setTimeout(removeAttributes, 500);
  setTimeout(removeAttributes, 1000);
});

// External links Warning 
document.addEventListener("DOMContentLoaded", function () {
  const excludedLinks = [
    'https://www.facebook.com/RosadosBox.LovePromiseJewelers/',
    'https://twitter.com/rosadosbox',
  ];

  const normalizeHost = (host) => host.replace(/^www\./, '');

  const isExternalLink = (url) => {
    try {
      const linkUrl = new URL(url, window.location.origin); // handles relative URLs
      const linkHost = normalizeHost(linkUrl.hostname);
      const currentHost = normalizeHost(window.location.hostname);

      return linkHost && linkHost !== currentHost;
    } catch {
      return false;
    }
  };

  const enhanceExternalLinks = () => {
    const links = document.querySelectorAll('a');

    links.forEach(link => {
      const href = link.getAttribute('href');

      if (
        !href ||
        excludedLinks.includes(href) ||
        link.matches('li[data-submenu-parent] > a') ||
        !isExternalLink(href)
      ) return;

      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');

      const linkText = link.textContent.trim();

      if (!link.hasAttribute('aria-label')) {
        link.setAttribute(
          'aria-label',
          `${linkText}, Redirecting to a third-party website (opens in a new tab).`
        );
      }

      const img = link.querySelector('img, svg');
      if (img) {
        const altText = img.getAttribute('alt') || '';
        const updatedAlt = altText
          ? `${altText}, Redirecting to a third-party website (opens in a new tab).`
          : 'Redirecting to a third-party website (opens in a new tab).';

        img.setAttribute('alt', updatedAlt);
      }
    });
  };

  const enhanceContactLinks = () => {
    const contactLinks = document.querySelectorAll(
      'a[href^="mailto:"], a[href^="tel:"]'
    );

    contactLinks.forEach(link => {
      const href = link.getAttribute('href');
      const linkText = link.textContent.trim();

      if (href.startsWith('mailto:')) {
        link.setAttribute('aria-label', `Email address: ${linkText}`);
      } else if (href.startsWith('tel:')) {
        link.setAttribute('aria-label', `Phone number: ${linkText}`);
      }
    });
  };

  enhanceExternalLinks();
  enhanceContactLinks();
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.testimonial-link a').forEach(function (link) {
    if (!link.getAttribute('href') || link.getAttribute('href').trim() === '') {
      link.remove();
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.grid_item.slick-slide').forEach(function (item) {
    item.removeAttribute('role');
    item.removeAttribute('aria-describedby');
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.testimonials-slide.slick-slide').forEach(function (item) {
    item.removeAttribute('role');
    item.removeAttribute('aria-describedby');
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.thumbnail[aria-describedby]').forEach(function (button) {
    button.removeAttribute('aria-describedby');
  });
});